import styled from "styled-components";

import colors from "../../../assets/css/colors";

export const Container = styled.div`
    display: flex;
    margin-top: 60px;

    @media (max-width: 500px){
        display: block;
    }
`;

export const Column = styled.div`
    display: block;
    width: 30%;
    margin-right: 38px;

    @media (max-width: 500px){
        width: 100%;
    }
`;

export const LogoContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 35px;
`;

export const LogoBackground = styled.div`
    width: 97px;
    height: 95px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px;
    background-color: ${colors.grayLight};
    border-radius: 8px;
`;

export const Logo = styled.img`
    max-width: 75px;
    max-height: 73px;
    height: auto;
    width: auto;
    object-fit: contain;
    background-color: transparent;
    border-radius: 5px;
`;

export const FieldTitle = styled.h2`
    font: normal normal normal 14px Circular Std Book;
    color: #454546;
    margin-bottom: 24px;
`;

export const DropzoneContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 25px;
`;

export const TranparentButton = styled.button`
    font: normal normal normal 11px/15px Circular Std Book;
    color: ${colors.primary};
    background-color: #FFF;
    border: 0px;
    outline: 0px;

    &:focus{
        outline: 0;
    }
`;

export const ButtonContainer = styled.div`
    width: 30%;

    @media (max-width: 500px){
        width: 100%;
    }
`